import ValidationMessageBanner from './ValidationMessageBanner.component';

export default ValidationMessageBanner;
